<template>
	<div class="block">
		<el-row type="flex" v-for="(item, index) in list" :key="index" class="blocK-list">
			<el-col v-for="e in item" :key="e.label">
				<span :class="[labelPosition == 'right' ? 'label-right' : 'label-left', 'label-position']"
					>{{ e.label }}:</span
				>
				<component
					:is="e.type"
					v-bind="e"
					v-on="$listeners"
					v-if="e.type"
					class="value"
				></component>
				<span v-else class="value">{{ e.value || '-' }}</span>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	props: {
		labelPosition: {
			type: String,
			default: 'right',
		},
		list: {
			type: Object,
		},
	},
};
</script>
<style scoped lang="scss">
.label-position {
  display: inline-block;
}

.label-right {
  text-align: right;
  width: 50%;
}

.label-left {
  text-align: left;
}

.value {
  margin-left: 5px;
  width: 50%;
}

.blocK-list {
  padding: 5px 0;
}

.block {
  padding-bottom: 20px;
}
</style>
